const Rate = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		fill="none"
		{...props}
	>
		<path
			stroke="#1E1E1E"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7ZM6 5V3M18 3v2M6.5 12h3M14.5 12h3M16 10.5v3"
		/>
	</svg>
);
export default Rate;
